import { render, staticRenderFns } from "./person-auth.vue?vue&type=template&id=5d262293&scoped=true&"
import script from "./person-auth.vue?vue&type=script&lang=js&"
export * from "./person-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d262293",
  null
  
)

export default component.exports